"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _products = require("../../store/entities/products/products.actions");

var _products2 = require("../../store/entities/products/products.selectors");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    image: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 185,
      height: 185,
      borderRadius: 3
    },
    imageSkeleton: {
      borderRadius: 5,
      marginBottom: spacing(1),
      width: 185,
      height: 185
    }
  };
});

var DefaultGift = function DefaultGift(_ref2) {
  var _product$denomination;

  var productId = _ref2.productId,
      denomination = _ref2.denomination,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'card' : _ref2$variant,
      boxProps = (0, _objectWithoutProperties2.default)(_ref2, ["productId", "denomination", "variant"]);
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var product = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return (0, _products2.getProductById)(productId);
  }, [productId]));
  var isLoading = !product;
  var isLoaded = !!product && (typeof denomination === 'undefined' || denomination === Number((_product$denomination = product.denomination) === null || _product$denomination === void 0 ? void 0 : _product$denomination.price));
  (0, _react.useEffect)(function () {
    if (isLoaded || !productId) {
      return;
    }

    dispatch((0, _products.fetchProduct)({
      productId,
      denomination
    }));
  }, [dispatch, productId, denomination, isLoaded]);

  if (variant === 'text') {
    var _product$localPrice, _product$localPrice2;

    return /*#__PURE__*/_react.default.createElement(_material.Box, boxProps, product ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, product.name, "\xA0", /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, {
      format: "".concat((_product$localPrice = product.localPrice) === null || _product$localPrice === void 0 ? void 0 : _product$localPrice.currencySign, "0,0.00")
    }, (_product$localPrice2 = product.localPrice) === null || _product$localPrice2 === void 0 ? void 0 : _product$localPrice2.price)) : /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
      variant: "text",
      width: 150
    }));
  }

  return /*#__PURE__*/_react.default.createElement(_material.Box, boxProps, !isLoading && product && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.image
  }, /*#__PURE__*/_react.default.createElement(_ui.MarketplaceProductImage, {
    src: product.images[0] || ''
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static-Bold"
  }, product.name)), product.localPrice && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, {
    format: "".concat(product.localPrice.currencySign, "0,0.00")
  }, product.localPrice.price)))), isLoading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    className: classes.imageSkeleton,
    variant: "rectangular"
  }), /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    width: 185,
    height: 26
  }), /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    width: 50,
    height: 20
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(DefaultGift);

exports.default = _default;